<template>
  <div class="talents-pool">
    <div style="text-align: left;padding: 20px">
      <el-button type="primary" size="small" icon="el-icon-download" @click="downloadResumeTemplate()" :disabled="$store.get('user').roleName !== 'admin'">模板下载
      </el-button>
      <el-upload
        class="upload-resume-template"
        :disabled="$store.get('user').roleName !== 'admin'"
        :action="UPLOAD_URI"
        :headers="{'auth-user': $store.get('Authorization')}"
        :data="{instanceName: 'Personnel'}"
        :show-file-list="false"
        :on-progress="uploadingFile"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :accept="'.xlsx'">
        <el-button size="small" :icon="uploadIcon" type="primary" :disabled="$store.get('user').roleName !== 'admin'">
          导入
        </el-button>
      </el-upload>
      <el-button type="primary" size="small" icon="el-icon-folder-opened" @click="exportUserInfo()">导出</el-button>
      <el-button type="primary" size="small" icon="el-icon-plus" :disabled="$store.get('user').roleName !== 'admin'"
                 @click="showChangeUserDialog(true)">新增
      </el-button>
      <el-button type="primary" size="small" icon="el-icon-edit" :disabled="$store.get('user').roleName !== 'admin'"
                 @click="showChangeUserDialog()">修改
      </el-button>
      <el-button type="primary" size="small" icon="el-icon-delete" :disabled="$store.get('user').roleName !== 'admin'"
                 @click="batchDeleteUsers()">删除
      </el-button>
      <el-button type="primary" size="small" icon="el-icon-refresh" @click="initQueryPersonnel()">刷新</el-button>
    </div>
    <ul style="padding: 10px 0;background-color: #F0F5FB;font-size: smaller">
      <!-- <el-table
         ref="multipleTable"
         width="100%"
         border
         maxHeight="600"
         :data="tableData"
         tooltip-effect="dark"
         @selection-change="handleSelectionChange">
         <el-table-column
           type="selection"
           width="40">
         </el-table-column>
         <el-table-column
           fixed="left"
           prop="userName"
           :show-overflow-tooltip="true"
           label="姓名"
           width="130">
         </el-table-column>
         <el-table-column
           prop="sexNum"
           label="性别"
           width="130"
           :show-overflow-tooltip="true">
         </el-table-column>
         <el-table-column
           prop="age"
           label="年龄（岁）"
           width="100"
           :show-overflow-tooltip="true">
         </el-table-column>
         <el-table-column
           prop="profession"
           label="技能"
           width="130"
           :show-overflow-tooltip="true">
           <template slot-scope="scope">
             <span>{{!!scope.row.profession ? scope.row.profession : '&#45;&#45;'}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="schoolName"
           label="毕业学校"
           width="150"
           :show-overflow-tooltip="true">
           <template slot-scope="scope">
             <span>{{!!scope.row.schoolName ? scope.row.schoolName : '&#45;&#45;'}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="jobExperienceName"
           label="工作经历"
           width="150"
           :show-overflow-tooltip="true">
           <template slot-scope="scope">
             <span>{{!!scope.row.jobExperienceName ? scope.row.jobExperienceName : '&#45;&#45;'}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="salaryName"
           label="期望薪资"
           width="150"
           :show-overflow-tooltip="true">
           <template slot-scope="scope">
             <span>{{!!scope.row.salaryName ? scope.row.salaryName : '&#45;&#45;'}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="phone"
           label="联系方式"
           width="150"
           :show-overflow-tooltip="true">
           <template slot-scope="scope">
             <span>{{!!scope.row.phone ? scope.row.phone : '&#45;&#45;'}}</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="desiredPosition"
           label="简介"
           width="500"
           :show-overflow-tooltip="true">
           <template slot-scope="scope">
             <span>{{!!scope.row.desiredPosition ? scope.row.desiredPosition : '&#45;&#45;'}}</span>
           </template>
         </el-table-column>
       </el-table>-->
      <li v-for="item in tableData" style="list-style: none;margin-top: 10px;background-color: white;padding: 5px 5px;">
        <el-row type="flex" align="middle" @click.native="userDetail1(item)">
          <el-col :span="6">
            <el-row type="flex" align="middle">
              <el-col :span="6">
                <el-checkbox style="display: flex;align-items:center" @change="(bo)=>handleSelectionChange(bo,item)" @click.native.stop="">
                  <el-avatar :src="item.image">头像</el-avatar>
                </el-checkbox>
              </el-col>
              <el-col :span="18" style="text-align: left">
                <el-tag>{{ item.userName }}</el-tag><br/>
                <label>{{ item.age }}岁 | {{ item.jobExperienceName }} | {{ item.educationName }} | {{item.resumePojo.jobStatus}}</label><br/>
                <label>期望：{{item.resumePojo.city}} | {{ item.desiredPosition }} | {{ item.salaryName }}</label>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="9" >
            <dl v-for="(item1,index) in item.listJobExperiences" :key="index">
              <dd style="margin-left: 0;text-align: left;padding-left: 5px">
                <span class="text-overflow" style="width: 130px;height: 17px">{{item1.startTime|dateFormat1}}-{{item1.endTime|dateFormat1}}</span>
                <span class="text-overflow" style="width: 150px;margin-left: 15px">{{item1.companyName}}</span>
                <span class="text-overflow" style="width: 100px;margin-left: 15px">{{item1.profession}}</span>
              </dd>
            </dl>
          </el-col>
          <el-col :span="9" >
             <dl v-for="(item1,index) in item.listEducationExperience" :key="index">
               <dd style="margin-left: 0;text-align: left;padding-left: 5px">
                 <span class="text-overflow" style="width: 170px">{{item1.startTime|dateFormat1}}-{{item1.endTime|dateFormat1}}&emsp;{{item1.experience}}</span>
                 <span class="text-overflow" style="width: 150px">{{item1.schoolName}}</span>
                 <span class="text-overflow" style="width: 100px">{{item1.major}}</span>
               </dd>
             </dl>
          </el-col>
        </el-row>
      </li>

    </ul>
    <div class="talent-pool-pagination" v-if="tableData.length > 0">
      <span class="des-tip">* 完整电话号码管理员方可见</span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>
    <el-drawer
      :visible.sync="drawer"
      :append-to-body="true"
      :title="userOpTitle"
      :before-close="handleClose">
      <div class="edit-user-info-drawer">
        <el-form label-width="100px" :model="editUserInfo" ref="userEditForm" :rules="userRules">
          <el-form-item label="用户名：" prop="userName">
            <el-input v-model="editUserInfo.userName" placeholder="请填写昵称"></el-input>
          </el-form-item>
          <el-form-item label="性别：">
            <el-radio-group v-model="editUserInfo.sex">
              <el-radio label="01">男</el-radio>
              <el-radio label="02">女</el-radio>
              <el-radio label="00">保密</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄：" prop="age">
            <el-input type="number" min="0" max="180" v-model="editUserInfo.age" placeholder="请填写年龄"></el-input>
          </el-form-item>
          <el-form-item label="技能：" prop="profession">
            <el-input v-model="editUserInfo.profession" placeholder="请填写技能"></el-input>
          </el-form-item>
          <el-form-item label="毕业学校：" prop="schoolName">
            <el-input v-model="editUserInfo.schoolName" placeholder="请填写毕业学校"></el-input>
          </el-form-item>
          <el-form-item label="工作经历：" prop="jobExperience">
            <el-select v-model="editUserInfo.jobExperience" placeholder="请选择">
              <el-option
                v-for="item in workExperienceOption"
                :key="item['dictNum']"
                :label="item['dictName']"
                :value="item['dictNum']">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="期望薪资：" prop="salary">
            <el-select v-model="editUserInfo.salary" placeholder="请选择">
              <el-option
                v-for="item in salaryRangeOption"
                :key="item['dictNum']"
                :label="item['dictName']"
                :value="item['dictNum']">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号码：" prop="phone">
            <el-input v-model="editUserInfo.phone" placeholder="请填写手机号码"></el-input>
          </el-form-item>
          <el-form-item label="简介：" prop="desiredPosition">
            <el-input type="textarea" :autosize="{minRows: 2}" v-model="editUserInfo.desiredPosition"
                      placeholder="请填写个人简介"></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-group">
          <el-button size="small" type="primary" @click="submitUserChange()">保存</el-button>
          <el-button size="small" @click="addUserFlag = drawer = false">取消</el-button>
        </div>
      </div>
    </el-drawer>
    <user-resume3 v-if="userDetailDialog" :showUserResumeFlag="userDetailDialog" :userInfo="userInfoX1" @hideUserResume="hideUserResume()"></user-resume3>
  </div>
</template>

<script>
import utilService from '../../utils/utilService'
import UserResume3 from '../Recruit/UserResume3'

export default {
  name: 'TalentsPool',
  components: {UserResume3},
  data () {
    let validateSyn = (rule, value, callback) => {
      utilService.checkSensitive({sensitive: value.trim()}, callback)
    }
    let validatePhone = (rule, value, callback) => {
      value = value || ''
      if (!value.trim() || utilService.isMobile(value.trim())) {
        callback()
      } else {
        callback(new Error('请填写正确的手机号！'))
      }
    }
    return {
      UPLOAD_URI: location.origin + '/recurit/user/batchImportPersonnel',
      tableData: [],
      multipleSelection: [],

      showUserResumeFlag: false,
      showUserResumeObj: null,

      userDetailDialog: false,
      userInfoX1: {},

      uploadIcon: 'el-icon-upload',
      page: {
        pageNum: 1,
        pageSize: 7, // todo 20
        total: 0
      },

      drawer: false,
      workExperienceOption: [],
      salaryRangeOption: [],
      editUserInfo: {},
      userOpTitle: '修改用户信息',
      addUserFlag: false,
      userRules: {
        userName: [{validator: validateSyn, trigger: 'blur'}],
        profession: [{validator: validateSyn, trigger: 'blur'}],
        schoolName: [{validator: validateSyn, trigger: 'blur'}],
        phone: [{validator: validatePhone, trigger: 'blur'}],
        desiredPosition: [{validator: validateSyn, trigger: 'blur'}]
      }
    }
  },
  methods: {
    /*导出word简历*/
    downloadResume (bo,item) {
      this.$http.get(this.$api.getUsrResume.url, {
        userCode: item.userCode
      }).then(_ => {
        utilService.downloadFileForStream(_, `个人简历_${item.userName || ''}.doc`, 'application/msword')
      })
    },

    downloadResumeTemplate () {
      utilService.downLoadFile(`${this.$api.getResumeTemplate.url}?name=人才储备&suffix=xlsx&pelativePath=template`, `人才储备.xlsx`)
    },
    uploadingFile () {
      this.uploadIcon = 'el-icon-loading'
    },
    uploadSuccess (response) {
      this.uploadIcon = 'el-icon-upload2'
      console.log(response)
      let _ = JSON.parse(response.replace(/(\d+):/g, '"$1":'))
      if (_ && _.code === 200) {
        if (_.data && Object.keys(_.data).length > 0) {
          let tip = ``
          Object.keys(_.data).forEach(key => {
            if (_.data[key].error.length > 0) {
              tip += `${_.data[key].error};`
            }
          })
          if (tip.length > 0) {
            this.$message.error(tip)
          } else {
            this.$message.success('导入成功！')
            this.initQueryPersonnel()
          }
        } else {
          this.$message.success('导入成功！')
          this.initQueryPersonnel()
        }
      } else {
        this.$message.error('导入失败！')
      }
    },
    uploadError (err) {
      console.log(err)
      this.uploadIcon = 'el-icon-upload2'
      this.$message.error('导入失败！')
    },
    exportUserInfo () {
      let userCodeList = this.multipleSelection.map(item => item.userCode)
      // this.$http.post(`${this.$api.exportQueryPersonnel.url}?fileName=人才储备&instanceName=Personnel`, userCodeList).then(_ => {
      //   debugger
      // })
      let uri = `${location.origin.includes('192.168.3.15') || location.origin.includes('localhost') ? location.origin + '/api' :
        location.origin}/recurit${this.$api.exportQueryPersonnel.url}?fileName=人才储备&instanceName=Personnel`
      fetch(uri, {
        method: 'POST',
        body: JSON.stringify(userCodeList),
        headers: {
          'auth-user': this.$store.get('Authorization'),
          'Content-Type': 'application/json;charset=UTF-8',
          responseType: 'blob'
        }
      }).then(_ => {
        _.blob().then(blob => {
          const link = document.createElement('a')
          link.style.display = 'none'
          // a 标签的 download 属性就是下载下来的文件名
          link.download = `人才储备导出_${new Date().getTime()}.xlsx`

          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
          // 释放的 URL 对象以及移除 a 标签
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        })
      })
    },
    handleCurrentChange (val) {
      console.log(val)
      this.page.pageNum = val
      this.initQueryPersonnel()
    },
    handleSizeChange (val) {
      console.log(val)
      this.page.pageSize = val
      this.initQueryPersonnel()
    },
    initQueryPersonnel () {
      this.$http.get(`${this.$api.queryPersonnel.url}?pageNum=${this.page.pageNum}&pageSize=${this.page.pageSize}`).then(_ => {
        if (_ && _.code === 200 && _.data && _.data.list) {
          this.tableData = _.data.list || []

          // this.tableData[1]['image'] = require('../../assets/logo.jpg')
          // console.log(this.tableData);

          this.page.pageSize = _.data.pageSize || this.page.pageSize
          this.page.pageNum = _.data.pageNum || this.page.pageNum
          this.page.total = _.data.total || this.page.total
        }
      })
    },
    handleSelectionChange (bo,val) {
      if (bo){
        this.multipleSelection.push(val);
      }else {
        this.multipleSelection=this.multipleSelection.filter(item=>item.id!=val.id)
      }
      console.log(this.multipleSelection)
    },
    showChangeUserDialog (addUserFlag) {
      if (addUserFlag) {
        this.userOpTitle = '添加用户信息'
        this.addUserFlag = addUserFlag
        this.editUserInfo = {}
        this.drawer = true
        return false
      }
      this.userOpTitle = '修改用户信息'
      if (this.multipleSelection.length === 0) {
        this.$confirm('请选择一条用户信息进行修改！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      } else if (this.multipleSelection.length > 1) {
        this.$confirm('一次只能修改一条用户信息，是否按选中的修改第一条？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.showChangeUserDialogHandle()
        })
      } else {
        this.showChangeUserDialogHandle()
      }
    },
    batchDeleteUsers () {
      if (this.multipleSelection.length === 0) {
        this.$confirm('请至少选择一条用户信息进行删除！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        return false
      } else {
        this.$confirm(`确认是否删除选中的${this.multipleSelection.length}条用户信息？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          let userCodeList = this.multipleSelection.map(item => item.userCode)
          this.$http.delete(this.$api.batchDeleteByCode.url, null, {data: userCodeList}).then(_ => {
            if (_.code === 200) {
              this.initQueryPersonnel()
              this.$message.success('删除成功！')
            } else {
              this.$message.error('删除失败！')
            }
          })
        })
      }
    },
    showChangeUserDialogHandle () {
      this.editUserInfo = Object.assign({}, this.multipleSelection[0])
      this.drawer = true
    },
    submitUserChange () {
      if (this.addUserFlag) {
        this.$confirm(`确认添加用户信息？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          let userInfo = {
            userName: this.editUserInfo.userName,
            sex: this.editUserInfo.sex,
            age: this.editUserInfo.age,
            profession: this.editUserInfo.profession,
            schoolName: this.editUserInfo.schoolName,
            residenceAddress: '',
            jobExperience: this.editUserInfo.jobExperience,
            salary: this.editUserInfo.salary,
            phone: this.editUserInfo.phone,
            desiredPosition: this.editUserInfo.desiredPosition
          }
          this.$http.post(this.$api.addPersonnelByUserCode.url, userInfo).then(_ => {
            if (_.code === 200) {
              this.addUserFlag = this.drawer = false
              this.initQueryPersonnel()
              this.$message.success('添加成功！')
            } else {
              this.$message.error(_.msg)
            }
          })
        })
      } else {
        this.$confirm(`确认是否修改有用户信息？`, '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          let userInfo = {// todo
            userCode: this.editUserInfo.userCode,
            userName: this.editUserInfo.userName,
            sex: this.editUserInfo.sex,
            age: this.editUserInfo.age,
            profession: this.editUserInfo.profession,
            schoolName: this.editUserInfo.schoolName,
            jobExperience: this.editUserInfo.jobExperience,
            salary: this.editUserInfo.salary,
            phone: this.editUserInfo.phone,
            desiredPosition: this.editUserInfo.desiredPosition
          }
          this.$http.put(this.$api.updatePersonnelByUserCode.url, userInfo).then(_ => {
            if (_.code === 200) {
              this.drawer = false
              this.initQueryPersonnel()
              this.$message.success('修改成功！')
            } else {
              this.$message.error(_.msg)
            }
          })
        })
      }
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          console.log(this.editUserInfo)
          done()
        })
        .catch(_ => {
        })
    },
    userDetail1 (item) {
      this.userDetailDialog = true
      this.userInfoX1 = item
    },
    hideUserResume () {
      this.userDetailDialog = false
      this.userInfoX1=null
    }
  },
  mounted () {
    this.initQueryPersonnel()
    if (location.origin.includes('127.0.0.1') || location.origin.includes('localhost')) {
      this.UPLOAD_URI = location.origin + '/api/recurit/user/batchImportPersonnel'
    }

    // 工作经验下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'EXPERIENCE'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.workExperienceOption = _.data
      }
    }).catch(e => {
      console.log(e)
    }).finally(f => {
      console.log(f)
    })

    // 薪资下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'SALARY'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.salaryRangeOption = _.data
      }
    }).catch(e => {
      console.log(e)
    }).finally(f => {
      console.log(f)
    })
  }
}
</script>

<style scoped>

.text-overflow {
  display:inline-block;/*内联对象需加*/
  word-break:keep-all;/* 不换行 */
  white-space:nowrap;/* 不换行 */
  overflow:hidden;/* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow:ellipsis;/* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
}

.talents-pool {
  text-align: center;
  width: 1200px;
  margin: auto;
  position: relative;
  background: #ffffff;
  min-height: calc(100vh - 245px);
}

.upload-resume-template {
  display: inline-block;
}

.talent-pool-pagination {
  width: 1200px;
  margin: auto auto 10px;
  text-align: right;
}

.des-tip {
  position: absolute;
  left: 5px;
  font-weight: bolder;
  margin-left: 15px;
  color: #F56C6C;
}

.el-button + .el-button {
  margin-left: 0;
}

.edit-user-info-drawer {
  width: 100%;
  height: 100%;
  padding: 20px;
}

/deep/ .el-drawer__header {
  margin-bottom: 0;
}

/deep/ .el-drawer__header > :first-child {
  font-size: 16px;
  outline: none;
  position: relative;
}

/deep/ .el-drawer__header > :first-child::before {
  position: absolute;
  content: '';
  width: 4px;
  height: 24px;
  background: #409EFF;
  left: -20px;
}

/deep/ .el-drawer__body {
  /*noinspection CssInvalidPropertyValue*/
  overflow: overlay;
}

/deep/ .btn-group {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/TalentsPool/TalentsPool.vue